import { ISortItem } from '../models/ISortItem';
import {
  SearchSortItemType,
  PurchaseReceiptSortItemType,
  BuyingActivitySortItemType,
  MarketplaceSortItemType,
  BackorderPolicySortItemType
} from '../types/SortItemTypes';
import { SortDirectionType } from '../types/SortDirectionType';

export function getSorts(
  sorts: ISortItem[],
  sortItemType: SearchSortItemType | PurchaseReceiptSortItemType | BuyingActivitySortItemType | MarketplaceSortItemType | BackorderPolicySortItemType,
  sortDirectionType: SortDirectionType
): ISortItem[] {
  //enable again if we want to support multi-sorting again
  // const clonedArrayToUpdate = [...sorts];
  // const existingSortIndex = clonedArrayToUpdate.findIndex(s => s.field === sortItemType);
  // if (existingSortIndex > -1) {
  //   if (sortDirectionType !== SortDirectionType.None) {
  //     clonedArrayToUpdate.splice(existingSortIndex, 1, { field: sortItemType, direction: sortDirectionType });
  //   } else {
  //     clonedArrayToUpdate.splice(existingSortIndex, 1);
  //   }
  // } else {
  //   clonedArrayToUpdate.push(<ISortItem>{ field: sortItemType, direction: sortDirectionType });
  // }
  // return clonedArrayToUpdate;

  //single soirting
  return sortDirectionType ? [<ISortItem>{ field: sortItemType, direction: sortDirectionType }] : [];
}
